module.exports = __webpack_public_path__ + "img/api-economy-solution.b8d6423c.svg";